import { TFunction } from "i18next";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";
import { Title } from "src/components";
import { colors } from "src/constants/colors";
import { FaTractor } from "react-icons/fa";
import { Element } from "react-scroll";




const Services = () => {
    const { t } = useTranslation("home");
    const servicesData = (t: TFunction) => [
        {
            title: t("services.items.agricultural_machinery.title"),
            description: t("services.items.agricultural_machinery.description"),
        },
        {
            title: t("services.items.irrigation_equipment.title"),
            description: t("services.items.irrigation_equipment.description"),
        },
        {
            title: t("services.items.seeds_seedlings.title"),
            description: t("services.items.seeds_seedlings.description"),
        },
        {
            title: t("services.items.fertilizers.title"),
            description: t("services.items.fertilizers.description"),
        },
        {
            title: t("services.items.pesticides.title"),
            description: t("services.items.pesticides.description"),
        },
        {
            title: t("services.items.animal_housing.title"),
            description: t("services.items.animal_housing.description"),
        },
        {
            title: t("services.items.animal_feed.title"),
            description: t("services.items.animal_feed.description"),
        },
        {
            title: t("services.items.veterinary_supplies.title"),
            description: t("services.items.veterinary_supplies.description"),
        },
        {
            title: t("services.items.agricultural_pumps.title"),
            description: t("services.items.agricultural_pumps.description"),
        },
        {
            title: t("services.items.mills_pressers.title"),
            description: t("services.items.mills_pressers.description"),
        },
        {
            title: t("services.items.light_equipment.title"),
            description: t("services.items.light_equipment.description"),
        }
    ];

    const services = servicesData(t);

    return (
        <Element name="services" className={styles.section}>
            <div className="container">
                <div className={styles.inlineCon}>

                    <Title
                        lgTitle={t("services.sub_title")}
                        smTitle={t("services.title")}
                        lgTitleColor={colors.heading}
                        smTitleColor={colors.primary}
                    />

                    <div className="row mt-5">
                        {services.map((item, index) => (
                            <div
                                key={item.title}
                                className="col-lg-4 col-md-6 col-12 mb-3 pb-2 px-2"
                                data-aos="fade-up"
                                data-aos-delay={index}
                                data-aos-anchor-placement="top-bottom"
                            >
                                <div className={styles.card}>

                                    <div className={styles.iconWrapper}>
                                        <FaTractor size={96} className={styles.icon} />
                                    </div>

                                    <h3 className={styles.cardTitle}>{item.title}</h3>
                                    <p className={`global-p ${styles.cardText}`}>
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </Element>
    );
};

export default Services;
